module.exports = __webpack_public_path__ + "static/img/baojingjiechu2.58abcb6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/baojingjiechu2.png
// module id = pZe0
// module chunks = 24